<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Usuario</th>
          <th>Fecha</th>
          <th>Saldo</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.id }}</td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td>
            <timeago
              :title="current.fecha_creacion"
              :datetime="current.fecha_creacion"
            ></timeago>
          </td>
          <td>{{ current.saldo }}</td>
          <td class="text-center">
            <span
              v-bind:class="{
                'status-pill green': current.estatus == true,
                'status-pill red': current.estatus == false,
              }"
            ></span>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  mounted() {
    let self = this;
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxc-linea_credito-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxc-linea_credito-editar",
          params: { id: current.id },
        });
      }
    },
  },
};
</script>
